module.exports = __webpack_public_path__ + "img/logo_game.6b2b96c6.png";